import { render } from "./contrat-form.vue?vue&type=template&id=74517e72"
import script from "./contrat-form.vue?vue&type=script&lang=js"
export * from "./contrat-form.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__